import { useContext } from 'react'
import { FlexGrid, Select, Typography } from '@telus-uds/components-web'
import STATIC_CONTENTS from 'src/blogBuilder/utils/staticContent'

import { articleConsumer } from 'src/blogBuilder/provider/ArticleProvider'

import { CategoriesContainer, CategoriesMainContainer, CategoryName } from './styles'
import useBBViewport from 'src/hooks/useBBViewport'
import { setFilterCategoryAnalyticsEvent } from '@/blogBuilder/analytics/setFilterCategoryAnalyticsEvent'

import { Language } from '@/siteBuilder/locale'
import { getCategoriesValue } from '../utils/getCategoriesValue'

type Props = {
  lang: Language
}

const Categories = ({ lang }: Props) => {
  const { allCategories, changeArticleByCategory, selectedCategory, setCount } = useContext(articleConsumer)
  const viewport = useBBViewport()

  const isMobile = () => {
    if (viewport === `xs` || viewport === 'sm') return true
    return false
  }

  const handleOnChangeCategory = (categoryName: string): void => {
    setCount(12)
    setFilterCategoryAnalyticsEvent(categoryName)
    changeArticleByCategory(categoryName)
  }

  const getAllCategories = () =>
    allCategories.map((category: { name: string }, index: number) => (
      <CategoriesMainContainer data-testid="categories-main-container" key={index}>
        <CategoriesContainer
          isSelected={category.name.toLowerCase() === selectedCategory.toLowerCase()}
          onClick={() => handleOnChangeCategory(category.name)}
          // TODO: deprecation warning
          onKeyPress={() => handleOnChangeCategory(category.name)}
          role="button"
          tabIndex={0}
          data-testid={`category-item-${index}`}
        >
          <CategoryName isSelected={category.name === selectedCategory}>
            <Typography>{category.name}</Typography>
          </CategoryName>
        </CategoriesContainer>
      </CategoriesMainContainer>
    ))

  return (
    <div data-testid="categories-container">
      {!isMobile() ? (
        <FlexGrid gutter={false}>
          <FlexGrid.Row>
            <FlexGrid.Col xs={0} md={12}>
              <FlexGrid.Row>{getAllCategories()}</FlexGrid.Row>
            </FlexGrid.Col>
          </FlexGrid.Row>
        </FlexGrid>
      ) : (
        <FlexGrid>
          <FlexGrid.Row>
            <FlexGrid.Col xs={12} md={0}>
              <Select
                value={getCategoriesValue(allCategories, selectedCategory, lang)}
                // TODO: Looks like placeholder no needed because value is always defined
                placeholder={STATIC_CONTENTS.PLEASE_SELECT[lang]}
                onChange={(e: string) => handleOnChangeCategory(e)}
              >
                {allCategories.map((category, index) => (
                  <Select.Item value={category.name} key={index}>
                    {category.name}
                  </Select.Item>
                ))}
              </Select>
            </FlexGrid.Col>
          </FlexGrid.Row>
        </FlexGrid>
      )}
    </div>
  )
}

export default Categories
